
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
     <b-skeleton-wrapper :loading="loading">
      <template #loading>
      <div class="card-number border-raduis-md bg-white box-shadow-xl-dark p-4">
          <div class="d-flex justify-content-end">
             <b-skeleton
              variant="light"
              height="30px"
              width="48px"
            ></b-skeleton>
          </div>
          <div class="number">
            <b-skeleton
              variant="light"
              height="100%"
              width="50%"
            ></b-skeleton>
          </div>
          <div class="title pt-3">
            <b-skeleton
              variant="light"
              height="15px"
              width="65%"
            ></b-skeleton>
            <b-skeleton
              variant="light"
              height="15px"
              width="100%"
            ></b-skeleton>
          </div>
        </div>
      </template>
      <div class="card-number text-white border-raduis-md bg-primary box-shadow-xl-dark p-4">
        <div class="text-right">
            <b-link :to="{ name: link }" class="bg-white py-1 px-3 rounded-pill text-secondary"><b-icon icon="arrow-right"></b-icon></b-link>
        </div>
        <div class="number">
          {{count}}
        </div>
        <div class="title">{{title}}</div>
        <div v-if="icon" class="icon">
            <img
              :src="require(`@/assets/images/sidebar-icons/${icon}`)"
              alt
            />
          </div>
      </div>
     </b-skeleton-wrapper>

  </div>
</template>

<script>
export default {
  name: 'CardNumber',
  props: ['link', 'count', 'title', 'icon', 'loading'],
};
</script>
